<!-- 服务项目信息编辑页 -->
<template>
  <div class="edit white">
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <el-form ref="form" :model="form" class="demo-ruleForm" label-width="120px" label-position="left">
            <el-form-item
              class="el-form-item-update"
              ref="shopName"
              label="姓名"
              prop="shopName"
              :rules="$rules.required"
            >
              <el-input v-model="form.shopName" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item
              class="el-form-item-update"
              ref="serviceTelephone"
              label="电话"
              prop="serviceTelephone"
              :rules="$rules.required"
            >
              <el-input v-model.number="form.serviceTelephone" placeholder="请输入电话"></el-input>
            </el-form-item>
            <el-form-item
              class="el-form-item-update"
              label="包间"
              prop="roomNum"
              :rules="$rules.zeroNum"
            >
              <el-input v-model.trim="form.roomNum" placeholder="请输入包间" :min="-1"></el-input>
            </el-form-item>
            <el-form-item
              class="el-form-item-update"
              ref="seatNum"
              label="卡座"
              prop="seatNum"
              :rules="$rules.bigNum"
            >
              <el-input v-model.trim="form.seatNum" placeholder="请输入卡座" :min="0"></el-input>
            </el-form-item>
            <el-form-item
              class="el-form-item-update"
              ref="address"
              label="详细地址："
              prop="address"
              :rules="$rules.required"
            >
              <div class="flex-row" id="keyword">
                <el-input type="text" v-model.trim="form.address" placeholder="请输入详细地址"></el-input>
              </div>
            </el-form-item>
        
            <el-form-item
              class="el-form-item-update"
              ref="description"
              label="门店简介："
              prop="description"
              :rules="$rules.required"
              style="height: 100%;"
            >
              <el-input type="textarea" v-model="form.description" style="margin: 10px 0;"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="drawer-footer">
          <div class="back el-icon-back" @click="back"></div>
          <div class="btns">
            <el-button type="primary" class="small-btn" @click="save">保存</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import drawer from "./drawer";
import minxin from "../../assets/javascript/minxin.js";
import { decrypt, encrypt } from "../../assets/javascript/untils";
export default {
  data() {
    return {
      codeName: true,
      time: 60,
      addEditShow: false,
      addEditTitle: "",
      mobileHide: false,
      positionList: [],
      form: {
        businessHour: {
          date: [],
          time: {
            start: "",
            end: ""
          }
        },
        organizeId: "",
        organizeName: "",
        joinType: "union",
        deliveryType: "shopTake",
        address: "",
        logo: "",
        imageList: [],
        videoList: null,
        ossIds: "",
        description: ""
        //roleIdList: '',
      },
      visibleDate: false,
      businessValue: "",
      paramsId: 0
      //attachmentList: [],
    };
  },
  mixins: [minxin],
  components: {
    drawer
  },

  computed: {},

  created() {
    this.form.headImgUrl = "";
    this.init();
  },
  methods: {
    back() {
      this.addEditShow = false;
    },

    radioChange(val) {
      this.form.priceType = val;
      if (val == "fixed") {
        this.form.priceRange = "";
      }
    },
    addLoginCode() {
      if (this.form.mobile == "") {
        this.$message.error("请输入手机号码");
        return false;
      }
      if (this.form.mobile.length != 11) {
        this.$message.error("请输入正确的手机号码");
        return false;
      }
      let arr = encrypt(
        JSON.stringify({
          mobile: this.form.mobile,
          bizType: "addstaff",
          millisecond: new Date().getTime()
        })
      );
      this.$api.post(this.$url.send, arr).then(resp => {
        if (resp) {
          this.codeName = false;
        } else {
          this.codeName = true;
          clearInterval(auth_timetimer);
        }
        this.time = 60;
      });
      let auth_timetimer = setInterval(() => {
        if (this.time <= 0) {
          this.time = 60;
          this.codeName = true;
          clearInterval(auth_timetimer);
        }
        this.time--;
      }, 1000);
    },
    // 上传组件成功回调
    getLogoFile(res) {
      this.form.logo = res;
    },
    deleteLogoFile(res) {
      this.form.logo = res;
    },
    getImgFile(res) {
      this.form.imageList.push(res);
    },
    deleteImgFile(res) {
      this.form.imageList = res;
    },
    //  页面初始化函数
    companyPositionPage() {
      this.$api
        .post(this.$url.companyPosition.page, { size: 100 })
        .then(res => {
          this.positionList = res;
        });
    },

    init() {
      this.$on("set", function(id) {
        this.companyPositionPage();
        Object.assign(this.$data, this.$options.data());
        this.paramsId = id;
        this.addEditTitle = "个人信息-编辑";
        this.$api
          .get(this.$url.shop.get, {
            id: id
          })
          .then(res => {
            if (res) {
              this.addEditShow = true;
              this.form = res;
              this.form.businessHour = JSON.parse(this.form.businessHour);
              if (this.form.imageList == null) {
                this.form.imageList = [];
              }
            }
          })
          .catch(error => {});
      });
    },
    handleChangeDrawer(val) {
      this.$refs["form"].clearValidate();
      this.addEditShow = false;
    },
    // 保存
    save() {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.form.businessHour.time.start =
            Number(this.startTime.split(":")[0]) * 60 +
            Number(this.startTime.split(":")[1]);
          this.form.businessHour.time.end =
            Number(this.endTime.split(":")[0]) * 60 +
            Number(this.endTime.split(":")[1]);
          this.form.businessHour.date.sort();
          if (this.form.businessHour.date.length == 6) {
            this.form.businessHour.allWeek = true;
          } else {
            this.form.businessHour.allWeek = false;
          }
          this.form.serviceTelephone = this.form.serviceTelephone;
          this.form.businessHour.workTime =
            this.businessValue + " " + (this.startTime + "-" + this.endTime);
          if (this.form.imageList.length > 0) {
            this.form.imgUrl = this.form.imageList[0].imgUrl;
          }
          this.$api.post(this.$url.shop.save, this.form).then(res => {
            if (res) {
              this.$api.success();
              this.addEditShow = false;
              this.$emit("handleChange", false);
            }
          });
        } else {
          this.scrollView(object);
        }
      });
    },
    // //滚动到指定位置
    scrollView(object) {
      for (let i in object) {
        let dom = this.$refs[i];
        dom.$el.scrollIntoView({
          block: "center",
          behavior: "smooth"
        });
        break;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "../../assets/css/edit.less";
// /deep/ .el-input--small .el-input__inner {
//   width: 200px;
//   height: 40px;
//   line-height: 40px;
// }
// /deep/ div .el-form-item--small .el-form-item__content,
// .el-form-item--small .el-form-item__label {
//   line-height: 40px;
// }
// /deep/ .el-date-editor.el-input,
// .el-date-editor.el-input__inner {
//   width: 200px;
// }
.pay-mains {
  padding: 0;
  /deep/ .el-form {
    padding-bottom: 20px;
    /deep/ .el-form-item {
      border-bottom: 1px solid @borderColor;
      padding: 10px 20px;
      margin-bottom: 0;
      &:last-child {
        border-bottom: 0;
      }
    }
    .el-form-item-update {
      padding: 0 20px;
      height: 46px;
      align-items: center;
      display: flex;
      margin: 0;
      justify-content: space-between;
      border-bottom: 1px solid @borderColor;
      /deep/ .el-form-item__label {
        font-size: 16px;
        font-weight: 500;
        // text-align: left;
      }
      /deep/ .el-form-item__content {
        flex: 2;
        text-align: right;
        // display: flex;
        .el-form-item__error {
          right: 0;
        }
      }
      /deep/ .el-input__inner {
        height: 40px;
        
        padding: 0;
        text-align: right;
      }
      /deep/.el-select .el-input__inner {
        padding: 0 30px;
      }
      /deep/ .el-radio__inner {
        width: 22px;
        height: 22px;
      }
      /deep/ .el-radio__label {
        font-size: 16px;
      }

      /deep/ .el-input.is-disabled .el-input__inner {
        background: #fff;
      }
      /deep/ .el-link {
        width: 160px;
      }
    }
    .el-form-item-dates {
      height: auto;
      min-height: 46px;
      display: flex;
      margin: 0;
      justify-content: space-between;
      .test {
        margin-left: -15px;
      }
    }
   
  }
}
.el-cascader {
  width: 202px !important;
}
.imgs {
  width: 110px;
  height: 110px;
}

/deep/ .el-checkbox-group {
  display: flex;
  flex-wrap: wrap;
}
/deep/ .el-checkbox {
  margin-right: 10px;
}
.el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0;
  margin-bottom: 10px;
}
</style>

<style lang="less">
.el-form-item-dates {
  /deep/ .el-form-item__content {
    margin-left: 98px !important;
  }
}
</style>